module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/6-a60ba7ae72b0ae823fa848c2cb3d9638.png";